import React from 'react';
import {TailSpin} from 'react-loader-spinner';
import {Container} from './styles';
import {theme} from '../../../styles/darkTheme';
import Logo from '../Logo';

interface LoadingSpinnerProps{
  height?: number;
  width?: number;
  small?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({height = 150, width = 150, small})=> {
  return<Container small={small}>
    <TailSpin color={theme.primary} height={height} width={width}/>
  </Container>
}

export default LoadingSpinner;
